{
	"description": "Entitlement Template for Confluence (Cloud) Free",
	"features": []
}
